/* eslint-disable @typescript-eslint/no-explicit-any */
import store from '@/app/store/store';

import { flowActionItemHtml, getSettingsHtml } from '../actions.html';
import type {
  FlowActionData,
  FlowActionDataEditor,
  TargetData,
  TargetDataEditor,
  EventDataEditor,
  EventData,
  Source,
} from '../type';
import TargetItem from './TargetItem';
import { allAtomsIntegration } from '../actions.config';
import { getAtomType } from '../../utils/getAtomType';
import { getEventData, mergeEventsToEditor, mergeFlowActionToEditor, mergeTargetToEditor } from '../actions.utils';
import CheckBoxesControl from '../../controlsv2/checkboxes';
import SidebarPopUp from '../../components/popup';
import RangePickerControl from '../../controlsv2/range-picker';
import DropdownControl from '../../controlsv2/dropdown';
import { app } from '@/store';
import { base } from '@/app/editor/sidebar/constant';
import { atomIDToBkID } from '@/app/utils/helpers';

/**
 * Flow Action Item
 */
export default class FlowActionItem implements FlowActionDataEditor {
  source: Source = { id: '', target: '' };
  events: EventDataEditor[];
  // eventsData: Event[];
  disableOn: string[] = [];
  targets: TargetDataEditor[];

  targetItems = {};

  $gfFrame = jQuery('#gfFrame');
  // $gryffEditor = this.$gfFrame.contents().find(".gryffeditor").first();
  $bodyEditor = this.$gfFrame.contents().find('body').first();
  // $gfContainer = jQuery("#gfContainer");
  $selectTargets: JQuery;
  $addTarget: JQuery;
  $actionList: JQuery;
  $atom: JQuery;
  atomID: string;
  atomLabel: string;
  atomType: string;

  $flowEventSettings: JQuery;

  $html: JQuery;
  $htmlDesHide: JQuery;
  flagRemoved = false;

  /**
   * constructor
   * @param $actionList ..
   * @param $atom ..
   * @param flowActionData ..
   */
  constructor($actionList: JQuery, $atom: JQuery, flowActionData: FlowActionData | undefined) {
    this.$actionList = $actionList;

    this.$atom = $atom;
    this.atomID = this.$atom.attr('id') || '';
    this.atomLabel = this.$atom.attr('data-label') || '';

    this.atomType = getAtomType(this.$atom);
    if (!this.atomID || !this.atomLabel) {
      return;
    }

    if (flowActionData != undefined) {
      const flowActionDataEditor = mergeFlowActionToEditor(flowActionData);
      this.source.id = flowActionDataEditor.source.id;
      this.source.target = flowActionDataEditor.source.target || this.getAtomTarget(this.$atom);
      this.events = flowActionDataEditor.events;

      // this.eventsData = flowActionDataEditor.eventsData;
      this.disableOn = flowActionDataEditor.disableOn || [];
      this.targets = flowActionDataEditor.targets;
    } else {
      //setup default
      this.source.id = '#' + this.atomID;
      this.source.target = this.getAtomTarget(this.$atom);
      this.events = mergeEventsToEditor([{ key: 'click' }]);
      this.targets = [this.getDefaultTarget()];
    }
    this.render();
    this.applyEvents();
  }

  /**
   * render
   */
  render(): void {
    this.$html = jQuery(
      flowActionItemHtml({
        source: this.source,
        events: this.events,
        disableOn: this.disableOn,
        targets: this.targets,
      }),
    );
    this.$actionList.append(this.$html);

    this.$htmlDesHide = this.$html.find('.des-hide');
    this.$flowEventSettings = this.$html.find('.flow-event-settings');

    return;
  }

  /**
   * applyEvents
   */
  applyEvents(): void {
    const _this = this;
    this.$html
      .find('.delete-action')
      .off('click')
      .on('click', function () {
        new SidebarPopUp({
          title: 'Deleting This Flow Actions?',
          description: 'This Flow Actions will be removed from your list.',
          primaryButton: {
            text: 'Delete',
            class: 'gf_btn-danger', // check or add class in style.scss on component
          },
          secondaryButton: {
            text: 'Cancel',
          },
          /**
           * On click delete
           */
          onClickedPrimary() {
            _this.remove();
          },
        });
      });

    //collapse
    this.$html
      .find('.flow-head')
      .off('click')
      .on('click', function (event) {
        //ignore if click delete
        if (jQuery(event.target).closest('.delete-action').length || jQuery(event.target).is('.delete-action')) {
          return;
        }

        const $flowItem = _this.$actionList.find('.flow-item');
        const $currentFlowItem = jQuery(this).closest('.flow-item');

        $flowItem.each(function () {
          if (jQuery(this).is($currentFlowItem)) {
            if (jQuery(this).hasClass('active')) {
              jQuery(this).removeClass('active').find('.flow-panel').stop(true, false).slideUp();
            } else {
              jQuery(this).addClass('active').find('.flow-panel').stop(true, false).slideDown();
            }
          } else {
            jQuery(this).removeClass('active').find('.flow-panel').stop(true, false).slideUp();
          }
        });
      });

    //add target
    this.$selectTargets = this.$html.find('.select-targets');
    for (let i = 0; i < this.targets.length; i++) {
      this.pushTarget(this.targets[i]);
    }
    this.countTarget();

    const $triggerOn = this.$html.find('.flow-trigger-on');
    const $checkboxes = $triggerOn.find('input[type=checkbox]');
    const opts = {
      /**
       * onChange
       * @param data .
       */
      onChange: (data: any) => {
        const name = data.name;
        const value: any = [];

        $triggerOn.find('input[name=' + name + ']:not(:checked)').each(function () {
          value.push(jQuery(this).val());
        });

        //value of checkbox is array
        _this.disableOn = value;
        store.setValue('update-action', 1);
      },
    };
    new CheckBoxesControl($checkboxes, opts);

    //button add new target
    this.$addTarget = this.$html.find('.add-target');

    //new target event
    this.$addTarget.off('click').on('click', function (e) {
      e.preventDefault();
      _this.pushTarget(_this.getDefaultTarget());
      store.setValue('update-action', 1);
    });

    //add event settings
    this.applyEventSettings();
  }

  /**
   * applyEventSettings
   */
  applyEventSettings(): void {
    // this.$flowEventSettings.

    const eventSettings = this.events[0].settings;
    if (!eventSettings || !eventSettings.length) {
      return;
    }

    const _this = this;

    for (let i = 0; i < eventSettings.length; i++) {
      //
      const name = eventSettings[i].key;
      const type = eventSettings[i].type;

      switch (type) {
        case 'select':
          this.$flowEventSettings.find('[name="' + name + '"]').each(function () {
            // Listen onChange
            const opts = {
              /**
               * /..
               * @param data aa
               */
              onChange: (data: any) => {
                _this.updateEventData(data.name, data.value);
              },
            };

            new DropdownControl(jQuery(this), opts);
          });
          break;
        case 'range':
          this.$flowEventSettings.find('[name="' + name + '"]').each(function () {
            // Listen onChange
            const opts = {
              /**
               * onChange
               * @param data .
               */
              onChange: (data: any) => {
                _this.updateEventData(data.name, data.value);
              },
            };
            // Object(_this.listSettings)[name] = new RangePickerControl(jQuery(this), opts);
            new RangePickerControl(jQuery(this), opts);
          });
          break;
        case 'checkbox':
          {
            // Listen onChange
            const $checkboxes = this.$flowEventSettings.find('[name="' + name + '"]');
            const opts = {
              /**
               * ...
               * @param data ...
               */
              onChange: (data: any) => {
                const name = data.name;
                const value = data.value;
                //value of checkbox is array
                _this.updateEventData(name, value);
              },
            };
            new CheckBoxesControl($checkboxes, opts);
          }
          break;
        /* case "button":
          {
            if (name == "preview-animation") {
              console.log(name);
              // Listen onChange
              const $button = this.$flowEventSettings.find("[name=\"" + name + "\"]");
              let timeOut: any;
              $button.off("click.click-btn").on("click.click-btn", function () {
                //console.log();
                //get duration
                const currentScreen = _this.getCurrentScreen();
                const dataScreen = _this.getDataActionByScreen(currentScreen);
                const delay = dataScreen.delay || 0;
                const duration = dataScreen.duration || 500;
                _this.runAnimate(dataScreen);
                jQuery(this).addClass("playing");

                if (timeOut) {
                  clearTimeout(timeOut);
                }

                timeOut = setTimeout(() => {
                  jQuery(this).removeClass("playing");
                }, duration + delay);

              });
            }


          }
          break; */
        default:
          break;
      }
    }
  }

  /**
   * updateEventData
   * @param name .
   * @param value .
   */
  updateEventData(name: string, value: any): void {
    if (!this.events[0].data) {
      this.events[0].data = {};
    }
    this.events[0].data[name] = value;
    store.setValue('update-action', 1);
  }

  /**
   * setEvents
   * @param events .
   */
  setEvents(events: EventData[]): void {
    const eventsData = [];
    //set Event Label
    for (let i = 0; i < events.length; i++) {
      const eventData = getEventData(events[i]);
      eventsData.push(eventData);
    }
    this.events = eventsData;
    this.refreshEvents();
    store.setValue('update-action', 1);
  }

  /**
   * refreshEvents
   */
  refreshEvents(): void {
    //change text
    this.$html.find('.flow-name').text(this.events[0].name);
    this.$html.find('.des-show').text(this.events[0].description);

    //
    let settingsHtml = '';
    if (this.events[0].settings && this.events[0].settings.length) {
      settingsHtml = getSettingsHtml(this.events[0].settings, this.events[0].data);
    }
    this.$flowEventSettings.html(settingsHtml);
    this.applyEventSettings();
  }

  /**
   * countTarget
   */
  countTarget(): void {
    const length = Object.keys(this.targetItems).length;
    const text = length > 0 ? `${length} targets` : `${length} target`;
    this.$htmlDesHide.text(text);
  }

  /**
   * pushTarget
   * @param target .
   */
  pushTarget(target: TargetDataEditor): void {
    const key = Object.keys(this.targetItems).length;
    Object(this.targetItems)[key] = new TargetItem(this.$selectTargets, target);
    Object(this.targetItems)[key].setDuplicateCallback(() => this.duplicateTarget(key));
  }

  /**
   * duplicateTarget
   * @param key .
   */
  duplicateTarget(key: number): void {
    const tempTargetItems = {};
    let range = 0;

    for (const i in this.targetItems) {
      const index = parseInt(i);
      Object(tempTargetItems)[index + range] = Object(this.targetItems)[index];

      if (key == index) {
        range++;
        const target = mergeTargetToEditor(Object(this.targetItems)[key].export());
        Object(tempTargetItems)[index + range] = new TargetItem(
          this.$selectTargets,
          target,
          Object(this.targetItems)[key].$html,
        );
        Object(tempTargetItems)[index + range].setDuplicateCallback(() => this.duplicateTarget(index + range));
      }
    }

    this.targetItems = tempTargetItems;
    store.setValue('update-action', 1);

    this.countTarget();
  }

  /**
   * getAtomTarget
   * @param $atom .
   * @returns ""
   */
  getAtomTarget($atom: JQuery): string {
    const label = $atom.attr('data-label');
    if (!label) {
      return '';
    }
    const config = allAtomsIntegration.get(label);
    if (!config || !config.target) {
      return '';
    }
    return config.target;
  }

  /**
   * getDefaultTarget
   * @returns .
   */
  getDefaultTarget(): TargetDataEditor {
    return {
      id: '#' + this.atomID,
      atomLabel: this.atomLabel,
      atomType: this.atomType,
      actions: [],
    };
  }

  /**
   * remove
   */
  remove(): void {
    this.$html.remove();
    this.flagRemoved = true;
    store.setValue('update-action', 1);
  }

  /**
   * export
   * @returns ..
   */
  export(): FlowActionData | undefined {
    if (this.flagRemoved) {
      return undefined;
    }
    const targets: TargetData[] = [];

    for (const key in this.targetItems) {
      const target = Object(this.targetItems)[key].export();
      if (target) {
        targets.push(target);
      }
    }

    const events = [];
    if (this.events) {
      for (let i = 0; i < this.events.length; i++) {
        const event = {
          key: this.events[i].key,
        };
        if (this.events[i].data && Object.keys(this.events[i].data).length) {
          Object(event)['data'] = this.events[i].data;
        }
        events.push(event);
      }
    }

    const source = {
      id: this.source.id,
    };
    if (this.source.target) {
      Object(source)['target'] = this.source.target;
    }

    const flowActionData = {
      source: source,
      events: events,
      targets: targets,
    };

    if (this.disableOn.length) {
      Object(flowActionData)['disableOn'] = this.disableOn;
    }

    return flowActionData;
  }
}
